export const applicationMsg  = {
    loanNotEligibleMsg  : 'The eligible amount appears to be less than permissible. Please recheck if income is captured correctly. Consider capturing secondary income as well, if applicable',
    duplicateData  : 'Duplicate applicant data',
    cibilRequestMessage : 'The request to fetch Cibil score is under processing, please check again before submitting the final application.'
};
